<footer>
    <br>
    <div class="footer-content">
      <!-- Your footer content goes here -->
      <p><i>Disclaimer: Please don’t include any confidential or sensitive information (including special category data) or information that could identify another person in your response</i></p>
    </div>
</footer>
  